import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import React, { useState } from 'react'

import { useTheme } from 'styled-components'

const Search = ({ onCloseHandler, queryString = '', style }) => {
  const [searchTerm, setSearchTerm] = useState(queryString)
  const theme = useTheme()

  const handleChange = e => setSearchTerm(e.target.value)

  const onSearch = e => {
    e.preventDefault()
    window.location.replace(`/search?q=${searchTerm}`)
    onCloseHandler()
  }

  return (
    <div className='search-wrapper'>
      <form onSubmit={onSearch}>
        <div className='search-input-container'>
          <input
            value={searchTerm}
            onChange={handleChange}
            type='search'
            name='search'
            placeholder='Search News12'
            autoComplete='off'
          />
          <button className='search-icon' type='submit'>
            <FontAwesomeIcon icon={faSearch} />
          </button>
        </div>
      </form>
      <style jsx>{`
        .search-wrapper {
          width: 100%;
        }

        form {
          width: 100%;
        }

        .search-input-container {
          position: relative;
          width: 100%;
        }

        input[type="search"] {
          width: 100%;
          height: 48px;
          border: 1px solid #e0e0e0;
          border-radius: 6px;
          padding: 12px 48px 12px 16px;
          font-family: Graphik, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          font-size: 16px;
          font-weight: 400;
          color: ${theme.colors.codGray};
          background: ${theme.colors.white};
          transition: all 0.3s ease-in-out;
          -webkit-appearance: none;
          box-sizing: border-box;
        }

        input[type="search"]::placeholder {
          color: ${theme.colors.mourineGray};
          font-weight: 400;
        }
        
        input[type="search"]:focus {
          outline: none;
          border-color: #007bff;
          box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
        }
        
        .search-icon {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: ${theme.colors.mourineGray};
          cursor: pointer;
          padding: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: color 0.2s ease-in-out;
        }
        
        .search-icon:hover {
          color: ${theme.colors.lightGray4};
        }
        
        input[type="search"]::-webkit-search-decoration,
        input[type="search"]::-webkit-search-cancel-button,
        input[type="search"]::-webkit-search-results-button,
        input[type="search"]::-webkit-search-results-decoration {
          display: none;
        }
        
        @media only screen and (max-width: 768px) {
          .search-wrapper {
            width: 100%;
            padding: 0;
          }
        }
      `}</style>
    </div>
  )
}

export default Search
